<template>
  <div class="home-container" @touchmove="onTouchMove">
    <div id="dom-map" class="map-content">
      <div class="header-content">
        <div class="search-section">
          <div class="left-back" @click="goBack"><van-icon name="arrow-left" size="16" /></div>
          <div class="search-content">
            <van-search v-model="searchVal" :placeholder="$t('form.storeNamePostCodeAddressCityVisitBa')" clearable @input="(val) => handleSearch(val, 'search')" @clear="(val) => handleSearch(val, 'clear')" />
          </div>
          <div v-if="pageType !== 'storeExpansion'">
            <img v-if="bascInfoChecked || storeBelongChecked || storeVisitChecked" class="filter-img" src="@/assets/images/guolvCheck.png" alt="" @click="handleFilter">
            <img v-else class="filter-img" src="@/assets/images/guolv.png" alt="" @click="handleFilter">
          </div>
        </div>
        <div class="map-status">
          <div class="status-content">
            <div class="status-item" :class="{'status-item-active': mapStatusType === subItem.value}" v-for="(subItem, subIndex) in mapStatusList" :key="subIndex" @click.prevent="handleStatus(subItem)">
              <span>{{ subItem.label }}</span>
              <div class="project-info" v-show="subItem.value === '1' && mapStatusType === '1'" @click.stop>
                <span class="line"></span>
                <van-dropdown-menu active-color="#307bff">
                  <van-dropdown-item v-model="productId" :options="productList" @open="posIndex = true" @closed="posIndex = false" />
                </van-dropdown-menu>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="storeMap" />
    </div>
    <MapList ref="mapListRef" :posIndex="posIndex" :mapData="mapData" :currentAddres="currentAddres" @mapGoTo="mapGoTo" :listRefresh="listRefresh" :pageType="pageType" @clearRequest="clearRequest" />
    <MapFilter ref="mapFilterRef" :deptOption="deptOption" @changeFilter="changeFilter" :mapType="mapType" />
    <IllustrationDes ref="illustrationDesRef" />
    <!-- <div class="map-mark" v-if="isShowMark">
      <div class="to-btn" @click="handleFirstView">View Stores on Map</div>
    </div> -->
  </div>
</template>

<script>
import { Loader } from '@googlemaps/js-api-loader'
// import { MarkerClusterer, GridAlgorithm } from '@googlemaps/markerclusterer'
import { mapState } from 'vuex'
import MapList from './components/mapList'
import MapFilter from './components/mapFilter'
import { arsCustomerAppMapListPageApi, deptTreeDeptApi } from '@/api/home'
import { customerExpansionMapListPageApi } from '@/api/storeExpansion'
import loadGoogleMaps from '@/utils/google-maps-loader'
import { Toast, Notify } from 'vant'
import axios from 'axios'

var map
var infoWindow
var geocoder = null
const loader = new Loader({
  apiKey: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
  version: 'weekly',
  libraries: ['places', 'drawing'], // 插件库
  region: 'US',
  language: 'en'
})
export default {
  name: 'StoreMap',
  components: {
    MapList,
    MapFilter,
    IllustrationDes: () => import('@/components/IllustrationDes')
  },
  data () {
    return {
      searchVal: '', // 搜索
      mapType: '0',
      productId: '',
      mapStatusType: '1',
      productList: [],
      mapStatusList: [
        { label: this.$t('shared.title.storeTag'), value: '0' },
        { label: this.$t('form.listed'), value: '1' }
      ],
      cancelTokens: [],
      legendImg: require('@/assets/images/tushi.png'),
      imgUrl: require('@/assets/images/a-dingwei2.png'),
      pinDataUrl: '',
      posIndex: false,
      mapData: [],
      markersArr: [],
      // 视口优化相关变量
      currentViewportBounds: null,
      viewportUpdateTimer: null,
      conditionForm: {
        // 基本信息
        search: '', // 搜索
        customerTag: '',
        shelfOperate: '',
        shelfProductIdList: [],
        deptIdList: [],
        userIdList: [],
        personVal: [],
        incentiveType: '',
        isPopUpEvent: '',
        isVisit: '',
        visitDay: '',
        visitStartDay: '',
        visitEndDay: '',
        reorderProductIdList: [],
        reorderOperate: '1',
        visitByBaVal: [''],
        visitUserIdList: [],
        isLastVisit: false
      },
      paginationList: {
        page: 1,
        limit: 100,
        total: 0
      },
      changeLatLng: {},
      isSearchOnce: false,
      mapZoom: 14,
      deptOption: [],
      currentAddres: '',
      listRefresh: false,
      map: null,
      pageType: 'Mapping',
      defaultImg: require('@/assets/images/icon_noimg.png')
      // isShowMark: false
    }
  },
  computed: {
    ...mapState({
      storeMaintainFilter: 'storeMaintainFilter',
      globalData: 'globalData',
      userInfo: 'myUserInfo'
    }),
    bascInfoChecked () {
      const {
        customerTag = '',
        shelfProductIdList = [],
        shelfOperate = '',
        incentiveType = '',
        isPopUpEvent = ''
      } = this.conditionForm
      return (
        customerTag !== '' ||
        shelfProductIdList.length > 0 ||
        shelfOperate !== '' ||
        incentiveType !== '' ||
        isPopUpEvent !== ''
      )
    },
    storeBelongChecked () {
      const {
        deptIdList = [],
        personVal = [],
        userIdList = []
      } = this.conditionForm
      return (
        deptIdList.length > 0 || personVal.length > 0 || userIdList.length > 0
      )
    },
    storeVisitChecked () {
      const { reorderProductIdList = [], reorderOperate = '1', isVisit = '', visitDay = '', visitStartDay = '', visitEndDay = '', visitUserIdList = [], isLastVisit = false, visitByBaVal = [''] } = this.conditionForm
      return (
        reorderProductIdList.length > 0 ||
        reorderOperate !== '1' ||
        isVisit !== '' ||
        visitDay !== '' ||
        visitStartDay !== '' ||
        visitEndDay !== '' ||
        visitUserIdList.length > 0 ||
        isLastVisit ||
        visitByBaVal.some(item => item !== '')
      )
    }
  },
  created () {
    this.pageType = this.$route.query.pageType || 'Mapping'
    this.conditionForm = {
      ...this.conditionForm,
      ...this.storeMaintainFilter
    }
    this.globalData.productList.forEach((subItem) => {
      this.productList.push({ text: subItem.productName, value: subItem.id })
    })
    this.productId = this.productList[0].value
    this.getMyVisit()
  },
  async mounted () {
    this.$refs.mapFilterRef.setDefaultVal(this.conditionForm)
    // if (window.localStorage.getItem('firstMap') === '1') {
    //   this.isShowMark = true
    //   window.localStorage.removeItem('firstMap')
    // } else {
    //   this.isShowMark = false
    // }
    const viewHeight =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight
    const mapDom = document.getElementById('storeMap')
    mapDom.style.height = `${viewHeight}px`
    const maps = await loadGoogleMaps() // 不传参数也会复用之前的
    geocoder = new maps.Geocoder()
    this.initMap()
    // geocoder = new google.maps.Geocoder()
  },
  activated () {
    if (this.pageType === 'storeExpansion') {
      this.mapStatusList = [
        { label: this.$t('form.listed'), value: '1' }
      ]
    } else {
      this.mapStatusType = '0'
    }
    this.searchVal = ''
    this.pageType = this.$route.query.pageType || 'Mapping'
    // 重新初始化地图和标记
    if (this.map && this.mapData.length > 0) {
      // 重新绘制所有标记
      this.drawMap(this.mapData)
      // 重新优化标记显示
      this.optimizeMarkerDisplay()
    }
  },
  deactivated () {
    // this.$destroy();
    // 取消所有未完成请求
    this.clearRequest()
    // 清理视口优化相关的定时器
    if (this.viewportUpdateTimer) {
      clearTimeout(this.viewportUpdateTimer)
      this.viewportUpdateTimer = null
    }

    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
  },
  methods: {
    onTouchMove (e) {
      if (!this.$refs.mapFilterRef.filterShow) {
        e.preventDefault()
      }
    },
    mapGoTo (params) {
      this.changeLatLng = params
      this.dataReset()
      this.getListData()
      this.map.setCenter(params)
    },
    dataReset () {
      this.clearRequest()
      for (let i = 0; i < this.markersArr.length; i++) {
        this.markersArr[i].marker.setMap(null)
      }
      this.markersArr = []
      this.mapData = []
      this.paginationList.page = 1
    },
    // 状态修改
    handleStatus (params) {
      if (params.value === '1') {
        this.productId = this.productList[0].value
      } else {
        this.productId = ''
      }
      this.mapStatusType = params.value
      this.dataReset()
      this.getListData()
    },
    getListData () {
      const {
        personVal,
        userIdList,
        visitDay,
        visitStartDay,
        visitEndDay,
        visitByBaVal,
        visitUserIdList
      } = this.conditionForm
      const data = {
        ...this.paginationList,
        ...this.conditionForm,
        userIdList: personVal.includes('Me')
          ? [...userIdList, this.userInfo.user.id]
          : userIdList,
        visitStartDay: visitDay === 'customizable' ? visitStartDay : visitDay ? visitDay.split('@')[0] : '',
        visitEndDay: visitDay === 'customizable' ? visitEndDay : visitDay ? visitDay.split('@')[1] : '',
        visitUserIdList: visitByBaVal.includes('Me') ? [...visitUserIdList, this.userInfo.user.id] : visitByBaVal.includes('') ? [] : visitUserIdList,
        sortField: '', // sortField ? sortField.split('-')[0] : '',
        order: '', // sortField ? sortField.split('-')[1] : '',
        limit: this.isSearchOnce ? 1 : 100,
        ...this.changeLatLng,
        productId: this.productId,
        distance: this.isSearchOnce ? '' : (17 - this.mapZoom) * 80 * 1000, // 250000
        search: this.searchVal
      }
      const source = axios.CancelToken.source()
      this.cancelTokens.push(source.cancel)
      if (this.paginationList.page === 1) {
        this.listRefresh = true
      }
      const requestApi = this.pageType === 'storeExpansion' ? customerExpansionMapListPageApi : arsCustomerAppMapListPageApi
      requestApi(data, source.token)
        .then((res) => {
          if (this.paginationList.page === 1) {
            this.mapData = []
          }
          this.paginationList.total = Number(res.data.totalRow)
          const newMapData = [...this.mapData]
          res.data.list.forEach((subItem) => {
            subItem.centerDistance = this.calculateDistance(
              this.changeLatLng.lat,
              this.changeLatLng.lng,
              subItem.lat,
              subItem.lng
            )
            const exists = newMapData.map((existingItem) => existingItem.id)
            if (!exists.includes(subItem.id)) {
              newMapData.unshift(subItem)
            }
          })
          newMapData.sort((a, b) => a.centerDistance - b.centerDistance)
          this.mapData = JSON.parse(JSON.stringify(newMapData))
          // 把新数组 与 原来的 数组 进行 合并
          // this.mapData = [...this.mapData, ...res.data.list]
          this.drawMap(res.data.list)
          this.listRefresh = false
        })
        .catch(() => {
          Toast.clear()
        })
        .finally(() => {
          // 移除已完成的取消函数
          const index = this.cancelTokens.indexOf(source.cancel)
          if (index !== -1) this.cancelTokens.splice(index, 1)
        })
    },
    handleFirstView () {
      this.isShowMark = false
      const { lng, lat } = this.$route.query
      if (lng) {
        this.changeLatLng = {
          lat: lat,
          lng: lng
        }
      } else {
        const currentTimeLoc = JSON.parse(
          window.localStorage.getItem('currentTimeLoc')
        )
        this.changeLatLng = {
          lat: currentTimeLoc.lat,
          lng: currentTimeLoc.lng
        }
      }
      this.clearRequest()
      this.paginationList.page = 1
      this.updateViewportBounds()
      this.optimizeMarkerDisplay()
      this.getListData()
    },
    // 地图初始化
    initMap (arr) {
      const { lng, lat } = this.$route.query
      const currentTimeLoc = JSON.parse(
        window.localStorage.getItem('currentTimeLoc')
      )
      if (lng) {
        this.getInitMap({ lng: parseFloat(lng), lat: parseFloat(lat) })
        return
      }
      if (currentTimeLoc) {
        this.getInitMap(currentTimeLoc)
      } else {
        // 三星手机不能频繁获取当前定位
        navigator.geolocation.getCurrentPosition(
          async (position) => {
            const newTimeLoc = {
              time: Date.now(),
              lat: position.coords.latitude,
              lng: position.coords.longitude
            }
            window.localStorage.setItem(
              'currentTimeLoc',
              JSON.stringify(newTimeLoc)
            )
            this.getInitMap(newTimeLoc)
          },
          () => {
            handleLocationError(true, infoWindow, this.map.getCenter())
          }
        )
      }
    },
    getInitMap (position) {
      loader.load().then(async () => {
        const { Map, InfoWindow } = await google.maps.importLibrary('maps')
        const { AdvancedMarkerElement } = await google.maps.importLibrary(
          'marker'
        )
        let centerLatLng = {
          lat: position.lat,
          lng: position.lng
        }
        if (process.env.NODE_ENV === 'development') {
          if (!this.$route.query.lng) {
            centerLatLng = {
              lat: -37.8367026, // 47.53441369999999, // 47.23396409999999, // 48.3040337, // 35.0504977,
              lng: 145.3308864 // -122.6278949 // -122.6436691 // -89.8394555
            }
          }
        } else {
          // 判断是否在某个国家境内，否 定位到该国固定经纬度
          if (!this.isInCountry(position.lat, position.lng) && !this.$route.query.lng) {
            if (process.env.VUE_APP_OSS_PREFIX === 'iccpp-uk') {
              centerLatLng = {
                lat: -37.8367026,
                lng: 145.3308864
              }
            } else {
              centerLatLng = {
                lat: 39.73644950000001,
                lng: -104.9889345
              }
            }
          }
        }
        this.currentLatLng = centerLatLng
        this.changeLatLng = centerLatLng
        infoWindow = new google.maps.InfoWindow()
        const styledMapType = new google.maps.StyledMapType(
          [
            {
              featureType: 'administrative.land_parcel',
              elementType: 'labels',
              stylers: [
                {
                  visibility: 'off'
                }
              ]
            },
            {
              featureType: 'poi',
              elementType: 'labels.text',
              stylers: [
                {
                  visibility: 'off'
                }
              ]
            },
            {
              featureType: 'poi.business',
              stylers: [
                {
                  visibility: 'off'
                }
              ]
            },
            {
              featureType: 'poi.park',
              elementType: 'labels.text',
              stylers: [
                {
                  visibility: 'off'
                }
              ]
            },
            {
              featureType: 'road.local',
              elementType: 'labels',
              stylers: [
                {
                  visibility: 'off'
                }
              ]
            }
          ],
          { name: 'Styled Map' }
        )
        this.map = new Map(document.getElementById('storeMap'), {
          center: centerLatLng,
          // center: { lat: 35.0504977 || parseFloat(arr[0].lat) || 22.5580928, lng: -89.8394555 || parseFloat(arr[0].lng) || 113.9417393 },
          // zoom: 2, // 14,
          zoom: 14,
          minZoom: 8,
          maxZoom: 16,
          gestureHandling: 'greedy',
          mapId: 'DEMO_MAP_ID',
          streetViewControl: false, // 隐藏街景小人
          mapTypeControl: false,
          fullscreenControl: false
        })
        // this.markerClusterer = new MarkerClusterer({ map, algorithm: new GridAlgorithm({gridsize: 30, maxDistance: 60000})})
        // this.markerClusterer = new MarkerClusterer({ map })
        this.map.mapTypes.set('styled_map', styledMapType)
        this.map.setMapTypeId('styled_map')
        this.getlocation(centerLatLng.lat, centerLatLng.lng)
        // this.resetPage()
        // this.getMapData()

        this.map.addListener('dragend', () => {
          if (this.timer) {
            clearTimeout(this.timer)
            this.timer = null
          }
          this.timer = setTimeout(() => {
            clearTimeout(this.timer)
            this.timer = null
            // this.getlocation(map.getCenter().lat(), map.getCenter().lng())1111
            this.changeLatLng = {
              lat: this.map.getCenter().lat(),
              lng: this.map.getCenter().lng()
            }
            this.clearRequest()
            this.paginationList.page = 1
            this.updateViewportBounds()
            // 立即优化当前标记显示
            this.optimizeMarkerDisplay()
            this.getListData()
          }, 1500)
        })
        this.map.addListener('dragstart', () => {
          this.$refs.mapListRef.currentStateIndex = 0
          this.$refs.mapListRef.calculatePanelHeight()
        })
        this.map.addListener('zoom_changed', () => {
          // 在这里添加你的代码，当地图的缩放级别发生改变时执行
          if (this.timer) {
            clearTimeout(this.timer)
            this.timer = null
          }
          this.timer = setTimeout(() => {
            clearTimeout(this.timer)
            this.timer = null
            this.mapZoom = this.map.getZoom()
            this.paginationList.page = 1
            this.clearRequest()
            this.updateViewportBounds()
            // 立即优化当前标记显示
            this.optimizeMarkerDisplay()
            this.getListData()
          }, 2000)
        })
        // 点击地图空白处关闭
        this.map.addListener('click', () => {
          infoWindow.close()
        })
        // 修复 OPPO 等手机关闭按钮不显示：替换为 SVG
        google.maps.event.addListener(infoWindow, 'domready', () => {
          const closeBtn = document.querySelector('.gm-ui-hover-effect')
          if (closeBtn) {
            closeBtn.innerHTML = `
              <svg width="18" height="18" viewBox="0 0 24 24" style="display:block;">
                <path d="M18 6L6 18M6 6l12 12" stroke="#666" stroke-width="2" fill="none" stroke-linecap="round"/>
              </svg>
            `
            closeBtn.style.display = 'flex'
            closeBtn.style.alignItems = 'center'
            closeBtn.style.justifyContent = 'center'
            closeBtn.style.width = '24px'
            closeBtn.style.height = '24px'
            closeBtn.style.padding = '0'
            closeBtn.style.border = 'none'
            closeBtn.style.background = 'transparent'
            closeBtn.style.cursor = 'pointer'
          }
        })
        // 回到中心点
        const centerControlDiv = document.createElement('div')
        centerControlDiv.style.padding = '5px'
        centerControlDiv.style.borderRadius = '3px'
        centerControlDiv.style.backgroundColor = '#fff'
        centerControlDiv.style.margin = '110px 0px 10px 10px'
        centerControlDiv.style.boxShadow = '0 2px 6px rgba(0,0,0,.3)'
        const centerControl = this.createCenterControl(
          this.map,
          centerLatLng,
          'center'
        )
        centerControlDiv.appendChild(centerControl)
        this.map.controls[google.maps.ControlPosition.LEFT_TOP].push(
          centerControlDiv
        )

        // 图示
        const legendDiv = document.createElement('div')
        legendDiv.style.padding = '5px'
        legendDiv.style.borderRadius = '3px'
        legendDiv.style.backgroundColor = '#fff'
        legendDiv.style.margin = '0px 0px 10px 10px'
        legendDiv.style.boxShadow = '0 2px 6px rgba(0,0,0,.3)'
        const legendControl = this.createCenterControl(this.map, centerLatLng, 'legend')
        legendDiv.appendChild(legendControl)
        this.map.controls[google.maps.ControlPosition.LEFT_TOP].push(legendDiv)

        const parser = new DOMParser()
        const markerSvg =
          '<svg class="icon" width="18px" height="18.00px" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M512 512m-486.61240522 0a486.61240522 486.61240522 0 1 0 973.22481044 0 486.61240522 486.61240522 0 1 0-973.22481044 0Z" fill="#d3e8ff" /><path d="M512 512m-272.22290474 0a272.22290474 272.22290474 0 1 0 544.44580948 0 272.22290474 272.22290474 0 1 0-544.44580948 0Z" fill="#0034a2" /></svg>'
        this.pinDataUrl = parser.parseFromString(
          markerSvg,
          'image/svg+xml'
        ).documentElement
        const currentTimeLoc = JSON.parse(
          window.localStorage.getItem('currentTimeLoc')
        )
        this.currentMarker = new AdvancedMarkerElement({
          map: this.map,
          position: {lat: currentTimeLoc.lat, lng: currentTimeLoc.lng },
          content: this.pinDataUrl,
          zIndex: google.maps.Marker.MAX_ZINDEX + 1
        })
        this.getListData()
      })
    },
    async drawMap (newArr) {
      const { AdvancedMarkerElement, PinElement } =
        await google.maps.importLibrary('marker')
      // 更新视口边界
      this.updateViewportBounds()
      newArr.forEach((item, index) => {
        const exists = this.markersArr.some(
          (existingItem) => existingItem.customerId === item.id
        )
        if (item.lat && !exists) {
          // '#0000f5' : '#ec8300'
          let typeColor = ''
          if (this.mapStatusType === '0') {
            typeColor = [1, '1'].includes(item.customerTag) ? '#ee541b' : [2, '2'].includes(item.customerTag) ? '#0db00b' : [3, '3'].includes(item.customerTag) ? '#aaaaaa' : '#307bff'
          } else if (this.mapStatusType === '1') {
            typeColor = item.isExist > 0 ? '#307bff' : '#aaaaaa'
          } else {
            typeColor = '#307bff'
          }
          // let newApartLastVisitDay = ''
          // if (item.visitDifferDay) {
          //   newApartLastVisitDay = item.visitDifferDay > 99 ? '99+' : item.visitDifferDay
          // }
          // // 建议的修改方案
          let newApartLastVisitDay = ''
          // 使用 typeof 检查可以确保 visitDifferDay 是数字（包括 0）时能被正确处理
          if (typeof item.visitDifferDay === 'number') {
            if (item.visitDifferDay > 99) {
              // 当天数超过99时，显示'99'，以满足2字符的限制
              newApartLastVisitDay = '99+'
            } else {
              // 将数字转换为字符串
              newApartLastVisitDay = String(item.visitDifferDay)
            }
          }
          const pinBackground = new PinElement({
            background: typeColor,
            borderColor: this.$route.query.customerId === item.id ? '#ff0000' : '#fff',
            glyphColor: 'white',
            glyph: newApartLastVisitDay,
            scale: this.$route.query.customerId === item.id ? 1.6 : 1
          })
          const marker = new AdvancedMarkerElement({
            map: this.map,
            position: { lat: parseFloat(item.lat), lng: parseFloat(item.lng) },
            content: pinBackground.element,
            gmpClickable: true,
            title: `${item.id}`
          })
          let htmlImg = `<img style="width: 50px; height: 50px; margin-right: 5px;" src="${this.defaultImg}" alt="" />`
          if (item.imgUrl && item.imgUrl.split(',')[0]) {
            htmlImg = `<img style="width: 50px; height: 50px; margin-right: 5px;" src="${item.imgUrl.split(',')[0]}" alt="" />`
          }
          let htmlShelfProductList = ''
          if (item.shelfProductList && item.shelfProductList.length > 0) {
            htmlShelfProductList = `<div style="display: flex; align-items: center; margin-top: 2px; font-size: 12px; margin-bottom: 5px;">
              <div style="max-width: 185px; padding: 0px 3px; border: 1px solid #307bff; color: #307bff; border-radius: 3px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                <span>(${item.shelfProductList.length})</span>
                <span>${item.shelfProductList.join(',')}</span>
              </div>
            </div>`
          }
          let htmlCustomerTagDutyName = ''
          let htmlCustomerTag = ''
          if ((!['', null].includes(item.customerTag) || item.dutyName) && ['storeMaintain'].includes(this.pageType)) {
            if (!['', null].includes(item.customerTag)) {
              const newCustomerTag = item.customerTag === 0 ? this.$t('shared.filter.toBeVerified') : item.customerTag === 1 ? this.$t('shared.filter.sVIPCore') : item.customerTag === 2 ? this.$t('shared.filter.vIPCore') : item.customerTag === 3 ? this.$t('shared.filter.potential') : ''
              const styleBorder = item.customerTag === 0 ? '1px solid #0db00b' : item.customerTag === 1 ? '1px solid #ee541b' : item.customerTag === 2 ? '1px solid #dc851f' : item.customerTag === 3 ? '1px solid #7f7f7f' : ''
              const styleColor = item.customerTag === 0 ? '#0db00b' : item.customerTag === 1 ? '#ee541b' : item.customerTag === 2 ? '#dc851f' : item.customerTag === 3 ? '#7f7f7f' : ''
              const styleBcColor = item.customerTag === 0 ? '#abdaaa' : item.customerTag === 1 ? '#eccfc4' : item.customerTag === 2 ? '#f0e2d1' : item.customerTag === 3 ? '#dcdcdc' : ''
              htmlCustomerTag = `<div style="max-width: 76px; padding: 3px 5px; text-align: center;font-size: 10px;margin-right: 5px;line-height: 13px; border: ${styleBorder}; color: ${styleColor}; background-color: ${styleBcColor}">${newCustomerTag}</div>`
            }
            htmlCustomerTagDutyName = `<div style="display: flex; align-items: center; width: 1850px;margin-top: 2px;margin-bottom: 5px;">
              ${htmlCustomerTag}
              <div style="flex: 1;">${this.$t('shared.bA')}：${item.dutyName}</div>
            </div>`
          }
          let htmlCustomerTypeDistance = ''
          if (item.customerType || item.distance) {
            const newDistance = this.formatDistance(item.distance)
            htmlCustomerTypeDistance = `<div style="display: flex; justify-content: space-between; color: #7f7f7f; margin-bottom: 5px; width: 185px;">
              <div><span>${item.customerType}</span></div>
              <div><span>${newDistance}</span></div>
            </div>`
          }
          let htmlAlready = ''
          if (item.isAllot === 1 && ['storeExpansion'].includes(this.pageType)) {
            htmlAlready = '<div style="color: #c4200b; margin-bottom: 5px;">Already in operation</div>'
          }
          let htmlStatus = ''
          if (item.status && item.status !== 1 && ['storeExpansion'].includes(this.pageType)) {
            htmlStatus = `<div style="color: #c4200b; margin-bottom: 5px;">${item.status === 1 ? this.$t('form.business') : item.status === -1 ? this.$t('form.temporarilyClosed') : item.status === -2 ? this.$t('form.permanentlyClosed') : item.status === -3 ? this.$t('form.invalid') : ''}</div>`
          }
          let htmlCity = ''
          let htmlAddress = ''
          const btnAddressClass = `address-btn-${item.id}`
          if (item.city) {
            htmlCity = `<span style="max-width: 62px; padding: 0px 2px; background-color: #9d6600; color: #fff; font-size: 10px; margin-right: 3px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">${item.city}</span>`
          }
          if (item.address) {
            htmlAddress = `<span class="${btnAddressClass}" style="flex: 1; padding: 0 3px; padding-left: 0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">${item.address}</span>`
          }
          const btnCustomerNameClass = `customer-name-btn-${item.id}`
          const htmlVal = `
            <div class="map-info" style="width: 240px; font-size: 11px;">
              <div class="${btnCustomerNameClass}" style="font-size: 14px; font-weight: bold; margin-bottom: 5px; text-overflow: ellipsis; color: #307bff; text-decoration: underline;">${item.customerName}</div>
              <div style="display: flex;">
                ${htmlImg}
                <div>
                  ${htmlShelfProductList}
                  ${htmlCustomerTagDutyName}
                  ${htmlCustomerTypeDistance}
                  ${htmlAlready}
                  ${htmlStatus}
                  <div style="width: 185px; display: flex; align-items: center;">
                    ${htmlCity}
                    ${htmlAddress}
                  </div>
                </div>
              </div>
            </div>
          `
          marker.addListener('click', () => {
            infoWindow.setContent(htmlVal)
            setTimeout(() => {
              const addressHtml = document.querySelector(`.${btnAddressClass}`)
              const customerNameHtml = document.querySelector(`.${btnCustomerNameClass}`)
              if (addressHtml) {
                addressHtml.onclick = (e) => {
                  this.copyToClipboard(item)
                  e.stopPropagation()
                }
              }
              if (customerNameHtml) {
                customerNameHtml.onclick = (e) => {
                  this.$refs.mapListRef.handleListItem({
                    type: 'details',
                    data: item
                  })
                  e.stopPropagation()
                }
              }
            })
            infoWindow.open(map, marker)
          })
          // 检查标记是否在视口内，控制显示/隐藏
          const isInViewport = this.isMarkerInViewport(item)
          marker.setMap(isInViewport ? this.map : null)
          this.markersArr.push({ title: item.id, marker, customerId: item.id })
        }
      })
      // 把 loading 设置为false，表示 可以进行 下一次请求了
      if (newArr.length > 0 && (this.mapData.length < this.paginationList.total || this.isSearchOnce)) {
        if (this.isSearchOnce) {
          this.isSearchOnce = false
          this.changeLatLng = {
            lat: parseFloat(newArr[0].lat),
            lng: parseFloat(newArr[0].lng)
          }
          this.map.setCenter(this.changeLatLng)
          this.paginationList.page = 1
        } else {
          this.paginationList.page++
        }
        this.getListData()
      } else {
        this.isSearchOnce = false
        // 所有数据加载完成后，优化标记显示
        this.optimizeMarkerDisplay()
      }
    },
    createCenterControl (map, centerLatLng, iconType) {
      const controlButton = document.createElement('img')
      // Set CSS for the control.
      controlButton.style.cursor = 'pointer'
      controlButton.title = 'Click to recenter the map'
      if (iconType === 'legend') {
        controlButton.src = this.legendImg
        controlButton.addEventListener('click', () => {
          this.$refs.illustrationDesRef.legendIsShow = true
        })
      } else if (iconType === 'center') {
        controlButton.src = this.imgUrl
        controlButton.addEventListener('click', () => {
          // map.setCenter(centerLatLng)
          this.dataReset()
          this.getCurrentLoc(map)
        })
      }
      // Setup the click event listeners: simply set the map to Chicago.
      return controlButton
    },
    formatDistance (value) {
      if (value === null || value === undefined || value === '' || isNaN(value)) {
        return ''
      }
      const distance = Number(value)

      if (distance < 1) {
        return `<1${this.$t('shared.metre')}`
      }
      if (distance < 100) {
        return Math.round(distance) + this.$t('shared.metre')
      }
      if (distance > 1000000) { // > 1000km
        return `>1000${this.$t('shared.kilometer')}`
      }
      // All remaining cases are between 100m and 1000km (inclusive)
      return (distance / 1000).toFixed(1) + this.$t('shared.kilometer')
    },
    copyToClipboard (params) {
      // 检查浏览器是否支持该 API
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(params.address)
          .then(() => {
            Notify({ type: 'success', message: this.$t('tips.addressCopiedSuccessfully'), duration: 1500 })
          })
          .catch(err => {
            console.error('Copy failed', err)
            Notify({ type: 'warning', message: this.$t('tips.addressCopiedFailed'), duration: 1500 })
          })
      } else {
        // 为不支持的旧浏览器提供降级方案（虽然很少见）
        Notify({ type: 'warning', message: this.$t('tips.browserDoesNotSupportCopyFunction'), duration: 1500 })
      }
    },
    // 获取当前位置
    getCurrentLoc (map) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { AdvancedMarkerElement } = await google.maps.importLibrary(
            'marker'
          )
          var pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          }
          window.localStorage.setItem(
            'currentTimeLoc',
            JSON.stringify({ ...pos, time: Date.now() })
          )
          this.currentLatLng = pos
          this.changeLatLng = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          }
          this.getListData()
          // this.getVisitPlanDetail()
          this.getlocation(pos.lat, pos.lng)
          this.currentMarker.setMap(null)
          map.setCenter(pos)
          // this.currentMarker = new google.maps.Marker({
          //   position: this.currentLatLng,
          //   clickable: true,
          //   icon: this.pinDataUrl,
          //   zIndex: google.maps.Marker.MAX_ZINDEX + 199, // google.maps.Marker.MAX_ZINDEX + 1,
          //   map: map
          // })
          this.currentMarker = new AdvancedMarkerElement({
            map,
            position: this.currentLatLng,
            content: this.pinDataUrl,
            zIndex: google.maps.Marker.MAX_ZINDEX + 1
          })
        },
        () => {
          handleLocationError(true, infoWindow, map.getCenter())
        }
      )
    },
    handleFilter () {
      this.$refs.mapFilterRef.filterShow = true
    },
    getMyVisit () {
      deptTreeDeptApi().then((res) => {
        this.deptOption = this.stripInPlace(res.data)
      })
    },
    stripInPlace (list) {
      list.forEach((node) => {
        if (Array.isArray(node.children)) {
          if (node.children.length) {
            this.stripInPlace(node.children)
          } else {
            delete node.children
          }
        }
      })
      return list
    },
    changeFilter (data) {
      if (data) {
        this.conditionForm = data
      }
      this.dataReset()
      this.isSearchOnce = true
      this.changeLatLng = { lat: '', lng: '' }
      this.getListData()
    },
    getlocation (lat, lng) {
      const $that = this
      // 根据经纬度获取位置
      geocoder.geocode(
        {
          location: new google.maps.LatLng(lat, lng)
        },
        function geoResults (results, status) {
          // 这里处理结果和上面一模一样
          if (status === google.maps.GeocoderStatus.OK) {
            // console.log('地理反解析结果：' + );
            // results[0].formatted_address
            // results[0].geometry.location
            // centerPoint.address = results[0].formatted_address
            // centerPoint.results = results
            // map.setCenter(centerPoint)
            // document.getElementById('postMessage').click()
            $that.currentAddres = results[0].formatted_address.split(',')[0]
            $that.$refs.mapListRef.cureentPos =
              results[0].formatted_address.split(',')[0]
          } else {
            console.log('：error ' + status)
          }
        }
      )
    },
    toSearch () {
      this.clearRequest()
      // this.$refs.mapListRef.
      this.$router.push(`/mapSearch?isSea=${this.mapType}`)
    },
    // 两个经纬度之间的距离
    calculateDistance (lat = '', lng = '', myLat = '', myLng = '') {
      const centerLat = lat
      const centerLng = lng

      const red1 = (myLat * Math.PI) / 180.0
      const red2 = (centerLat * Math.PI) / 180.0
      const a = red1 - red2
      const b = (myLng * Math.PI) / 180.0 - (centerLng * Math.PI) / 180.0
      const R = 6378137
      const distance =
        R *
        2 *
        Math.asin(
          Math.sqrt(
            Math.pow(Math.sin(a / 2), 2) +
              Math.cos(red1) * Math.cos(red2) * Math.pow(Math.sin(b / 2), 2)
          )
        )
      const res = (distance / 1000).toFixed(2) * 1

      return res
    },
    // 更新视口边界
    updateViewportBounds () {
      if (this.map) {
        this.currentViewportBounds = this.map.getBounds()
      }
    },
    // 判断标记是否在当前视口内
    isMarkerInViewport (item) {
      if (!this.currentViewportBounds || !item.lat || !item.lng) {
        return true // 如果没有视口信息，默认显示
      }

      const markerLatLng = new google.maps.LatLng(
        parseFloat(item.lat),
        parseFloat(item.lng)
      )
      return this.currentViewportBounds.contains(markerLatLng)
    },
    // 优化标记显示
    optimizeMarkerDisplay () {
      if (this.viewportUpdateTimer) {
        clearTimeout(this.viewportUpdateTimer)
      }

      this.viewportUpdateTimer = setTimeout(() => {
        this.updateViewportBounds()

        // 隐藏视口外的标记
        this.markersArr.forEach((markerObj) => {
          const markerData = this.mapData.find(
            (item) => item.id === markerObj.customerId
          )
          if (markerData) {
            const isVisible = this.isMarkerInViewport(markerData)
            markerObj.marker.setMap(isVisible ? this.map : null)
          }
        })
      }, 300)
    },
    isInCountry (lat, lng) {
      if (process.env.VUE_APP_OSS_PREFIX === 'iccpp-uk') {
        // 英国的大致地理边界（矩形区域）
        const UK_BOUNDS = {
          north: 60.85, // 最北端纬度 (设得兰群岛)
          south: 49.86, // 最南端纬度 (英吉利海峡)
          west: -8.65, // 最西端经度 (北大西洋)
          east: 1.76 // 最东端经度 (北海)
        }
        // 检查坐标是否在边界内
        return (
          lat >= UK_BOUNDS.south &&
          lat <= UK_BOUNDS.north &&
          lng >= UK_BOUNDS.west &&
          lng <= UK_BOUNDS.east
        )
      } else {
        // 判断用户是否在美国境内
        // 美国本土（连续48州）范围
        const isInMainland = lat >= 24.396308 && lat <= 49.384358 && lng >= -125.0 && lng <= -66.93457

        // 阿拉斯加范围
        const isInAlaska = lat >= 51.0 && lat <= 71.5 && lng >= -170.0 && lng <= -140.0

        // 夏威夷范围
        const isInHawaii = lat >= 18.0 && lat <= 23.0 && lng >= -160.0 && lng <= -154.0

        return isInMainland || isInAlaska || isInHawaii
      }
    },
    goBack () {
      this.clearRequest()
      if (localStorage.getItem('centerPoint')) {
        localStorage.removeItem('centerPoint')
      }
      this.$router.go(-1)
      this.$destroy()
    },
    handleSearch (val, type) {
      if (this.searchVal === '') {
        // this.dataReset()
        this.markersArr = []
        this.isSearchOnce = true
        this.changeLatLng = this.centerLatLng // { lat: '', lng: '' }
        this.changeFilter()
      }
      if (type === 'search' && this.searchVal !== '') {
        if (this.timer) {
          clearTimeout(this.timer)
          this.timer = null
        }
        this.timer = setTimeout(() => {
          clearTimeout(this.timer)
          // this.listRefresh = true
          this.changeFilter(this.conditionForm)
        }, 800)
      }
    },
    // 清除剩余请求
    clearRequest () {
      this.cancelTokens.forEach(cancel => cancel('组件销毁，取消请求'))
      this.cancelTokens = []
    }
  }
}
</script>

<style scoped lang="less">
.map-content {
  position: relative;
  font-size: 12px;
  #storeMap {
    // border: 1px solid #000;
  }
  .header-content {
    width: 100%;
    position: absolute;
    z-index: 96;
    .search-section {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 52px;
      padding: 0px 10px;
      // background: linear-gradient(180deg, #fff, #fff, transparent);
      background-color: #fff;
      .left-back {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 30px;
        height: 52px;
      }
    }
    .map-status {
      margin-top: 10px;
    }
    .search-content {
      display: flex;
      align-items: center;
      flex: 1;
      height: 100%;
      margin-right: 10px;
      // padding-left: 10px;
      // margin-right: 10px;
      // line-height: 33px;
      // border-radius: 20px;
      // border: 1px solid gray;
      // background-color: #f7f8fa;
      /deep/.van-search {
        width: 100%;
        padding: 0;
        .van-search__content {
          border-radius: 16px;
        }
      }
    }
    .status-content {
      display: flex;
      align-items: center;
      padding: 0px 10px;
      .status-item {
        height: 30px;
        line-height: 30px;
        padding: 0 5px;
        background-color: #bababa;
        color: #000;
        margin-right: 5px;

        display: flex;
        align-items: center;
        .project-info {
          display: flex;
          align-items: center;
          .line {
            width: 1px;
            height: 16px;
            margin: 0 5px;
            background: #fff;
          }
          /deep/.van-ellipsis {
            font-size: 12px;
          }
        }
        /deep/.van-dropdown-menu__bar {
          height: auto;
          font-size: 12px;
          background-color: transparent;
        }
        /deep/.van-dropdown-menu__title {
          padding-left: 0;
        }
        /deep/.van-dropdown-item__content {
          min-width: 166px;
          max-width: 206px;
          left: 123px;
          .van-dropdown-item__option {
            padding: 10px;
            .van-cell__title {
              font-size: 12px;
            }
            .van-cell__value {
              flex: none;
              width: 20px;
            }
          }
        }
        &:nth-child(2) {
          padding: 0 10px;
        }
        &:last-child {
          margin-right: 0px;
        }
      }
      .status-item-active {
        color: #fff;
        background-color: #307bff;
        /deep/.van-dropdown-menu__title {
          color: #fff !important;
          &::after {
            border-color: transparent transparent #fff #fff;
          }
        }
      }
    }
    .filter-img {
      width: 20px;
      height: 20px;
    }
  }
}
.map-mark {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.7);
  .to-btn {
    padding: 16px 30px;
    border-radius: 16px;
    background-color: #307bff;
    color: #fff;
  }
}
</style>
